<template>
  <component
    :is="'CellSummary_' + item.cellSummaryComponent"
    v-if="item.cellSummaryComponent"
    :cmpObj="{
      item: item,
      total: total,
    }"
  ></component>
  <span
    v-else-if="item !== undefined"
    :style="item.total_color ? item.total_color(item) : null"
  >
    {{ item.total_content ? item.total_content(item) : total }}
  </span>

  <span
    v-else
    :style="item.total_color ? item.total_color(total) : null"
  >
    {{ item.total_content ? item.total_content(total) : total }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  summaryParams: {
    type: Object,
    required: true,
  },
});
const total = computed(() => {
  let totla: any = 0;
  for (const item of props.summaryParams.pageData) {
    let itemValue = item[props.summaryParams.column.dataIndex];
    itemValue = getValue(itemValue);

    if (isNaN(itemValue) || itemValue == null) {
      itemValue = 0;
    }
    totla = add(totla, itemValue);
  }

  return totla;
});
function add(a, b) {
  const precision = Math.max(
    (a.toString().split('.')[1] || '').length,
    (b.toString().split('.')[1] || '').length,
  );
  return parseFloat((a + b).toFixed(precision));
}
const getValue = (value: any) => {
  if (typeof value === 'string') {
    value = parseFloat(value);
  }
  return value;
};
</script>
<style lang="less" scoped></style>
